import React, { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress
} from "@mui/material";
import { fetchUsers } from "../services/api";
import UserMessagesModal from "./UserMessagesModal"; // Βάλε το νέο modal εδώ!

export default function UsersTable({ token }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedUser, setSelectedUser] = useState(null); // <-- προσθέτεις state για το modal

  useEffect(() => {
    setLoading(true);
    setError("");
    fetchUsers(token)
      .then((data) => {
        if (Array.isArray(data)) {
          setUsers(data);
        } else {
          setUsers([]);
          setError(data?.msg || "Δεν βρέθηκαν χρήστες ή έληξε το session.");
        }
      })
      .catch((err) => {
        setUsers([]);
        setError("Σφάλμα σύνδεσης ή δικαιωμάτων.");
      })
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <>
      <TableContainer component={Paper} sx={{ maxWidth: 850, mx: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Full Name</TableCell>
              <TableCell>Gender</TableCell>
              <TableCell>Personality</TableCell>
              <TableCell>Created</TableCell>
              <TableCell align="center">Chat</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={6} align="center" style={{ color: "red" }}>{error}</TableCell>
              </TableRow>
            ) : users.length ? users.map(u => (
              <TableRow key={u.id}>
                <TableCell>{u.id}</TableCell>
                <TableCell>{u.name || "-"}</TableCell>
                <TableCell>{u.gender || "-"}</TableCell>
                <TableCell>
                  {u.personality ? JSON.stringify(u.personality) : "-"}
                </TableCell>
                <TableCell>{u.created_at}</TableCell>
                <TableCell align="center">
                  <Button size="small" variant="outlined" onClick={() => setSelectedUser(u)}>
                    Προβολή
                  </Button>
                </TableCell>
              </TableRow>
            )) : (
              <TableRow>
                <TableCell colSpan={6} align="center">No users found.</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* --- Modal για τα μηνύματα του χρήστη --- */}
      <UserMessagesModal
        open={!!selectedUser}
        user={selectedUser}
        token={token}
        onClose={() => setSelectedUser(null)}
      />
    </>
  );
}
